import React from "react";
import { TouchableHighlight } from "react-native";
import { InlineRichText } from "../../components/RichText";
import { Document } from "@contentful/rich-text-types";
import fpo from "../../resources/img/FPO-Background.png";
import { Container, Tile, Title } from "./styles";

type SafetyStrategyItemProps = {
	imageSource: any;
	title?: string;
	titleRich?: Document;
	onPress?: () => void;
};

const SafetyStrategyItem = ({
	imageSource,
	title,
	titleRich,
	onPress,
}: SafetyStrategyItemProps) => {
	const theTitle = titleRich ? <InlineRichText doc={titleRich} /> : title;
	return (
		<TouchableHighlight onPress={() => onPress?.()}>
			<Container>
				<Tile source={imageSource || fpo} />
				<Title type="ctah4">{theTitle}</Title>
			</Container>
		</TouchableHighlight>
	);
};

export default SafetyStrategyItem;
